import { ProductShared } from '@/modules/products/shared/types';
import { cart_store } from '@/store';
import { Products } from '@/modules/products/types';
import CatalogProductItem = Products.CatalogProductItem;

export const check_item_in_cart = (prod: ProductShared) =>
  cart_store.state.carts_products.some((cart_item) => cart_item.product.id === prod.id);

export const check_item_in_cart1 = (prod: CatalogProductItem) =>
  cart_store.state.carts_products.some((cart_item) => cart_item.product.id === prod.id);
